import React, { useState } from "react";
import "./Solution.css";

export default function SolutionCard({
  title,
  description,
  specificRoles,
  date,
  number,
  organization,
  client,
  image,
  link,
}) {
  const [activeTab, setActiveTab] = useState("description"); // default tab

  return (
    <div className="solution-card">
      {/* LEFT: Text */}
      <div className="text-content">
        <div className="solution-time">
          <p className="date">{date}</p>
        </div>

        <h2 className="title">{title}</h2>

        {/* Tabs */}
        <div className="tabs">
          <span
            className={activeTab === "description" ? "tab active" : "tab"}
            onClick={() => setActiveTab("description")}
          >
            Description
          </span>
          <span
            className={activeTab === "roles" ? "tab active" : "tab"}
            onClick={() => setActiveTab("roles")}
          >
            Specific Roles
          </span>
        </div>

        {/* Tab content */}
        <div className="tab-content">
          {activeTab === "description" && (
            <p className="description">{description}</p>
          )}

          {activeTab === "roles" && (
            <ol className="responsibilities-list">
              {specificRoles?.map((role, index) => (
                <li key={index}>{role}</li>
              ))}
            </ol>
          )}
        </div>

        <div className="solution-footer">
          <p>
            <strong>Organization:</strong> {organization} |{" "}
            {/* <strong>Client:</strong> {client} */}
          </p>
        </div>
      </div>

      {/* RIGHT: Image */}
      <div className="image-container">
        <div className="solution-number">{number}</div>
        <img src={image} alt={title} className="solution-image" />

        <a
          className="view-dashboard"
          href="https://drive.google.com/file/d/1OW-VR3Rh6zHk1H9Tys8xsHN0T7BeG0C3/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          Request Access
        </a>
      </div>
    </div>
  );
}
